<template>
  <div>
    <!-- <div class="tabs is-marginless-bottom has-bg-light">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active' : tab === 'option'}" v-if="options && options.length">
          <a @click="selectTab('option')">En cours</a>
        </li>
        <li :class="{'is-active' : tab === 'proposal'}" v-if="proposals && proposals.length">
          <a @click="selectTab('proposal')">Historique</a>
        </li>
      </ul>
    </div> -->
    <div class="columns is-vcentered is-gapless is-padding-right is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('option')" :class="{'is-active': tab === 'option'}"
            v-if="runningOptions && runningOptions.length">En cours ({{runningOptions.length}})</a>
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('proposal')" :class="{'is-active': tab === 'proposal'}"
            v-if="pastOptions && pastOptions.length">Historique ({{pastOptions.length}})</a>
        </div>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-marginless-bottom">
      <thead>
      <tr class="is-size-6">
        <th><span>Date</span></th>
        <th><span>Programme</span></th>
        <th><span>Référence du Lot</span></th>
        <th v-if="isAdmin && isDistributeurMode"><span>Promoteur</span></th>
        <th><span>Collaborateur</span></th>
        <th><span>Statut</span></th>
      </tr>
      </thead>
      <tbody class="is-size-5 has-text-text">
      <tr v-for="o in currentOptions" :key="o.pk" class="is-size-6">
        <td>
          <span>{{o.start_date|prettyDate}}</span>
        </td>
        <td>
          <span>{{o.program_name}}</span>
        </td>
        <td>
          <span>{{o.lot_ref}}</span>
        </td>
        <td v-if="isAdmin && isDistributeurMode">
          <span>{{o.promoteur_name}}</span>
        </td>
        <td>
          <span>{{o.seller_name|smallName}}</span>
        </td>
        <td>
          <span>{{o.status|optionStatusLabel}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ContactOptionList',
    data () {
      return {
        tab: 'option'
      }
    },
    mixins: [DefaultValues],
    props: {
      sourceOptions: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isDistributeurMode']),
      currentOptions () {
        if (this.tab === 'option') {
          return this.runningOptions
        } else {
          return this.pastOptions
        }
      },
      runningOptions () {
        let okStatus = ['pending', 'approved', 'waiting_list']
        return this.sourceOptions.filter(x => {
          return okStatus.includes(x.status)
        })
      },
      pastOptions () {
        let okStatus = ['refused', 'expired', 'canceled_by_admin', 'canceled_by_seller']
        return this.sourceOptions.filter(x => {
          return okStatus.includes(x.status)
        })
      }
    },
    methods: {
      selectTab (value) {
        this.tab = value
      }
    },
    created () {
      if (this.currentOptions.length > 0) {
        this.tab = 'option'
      } else {
        this.tab = 'proposal'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactOptionList.vue